export default __webpack_public_path__ + "static/media/UserDefault.e73b1386.jpeg";